import classnames from "classnames";
import React from "react";
import { IMessage } from "../../../@DTO/chat";
import { ButtonCopyMessage } from "./ButtonCopyMessage";
import UserMessage from "./UserMessage";
import AIMessage from "./IaMessage";
import DotsTheme from "../../../components/ComponentsPageBrad/DotsTheme";
import { useTheme } from "../../../contexts/ThemeContext";
import NappiesCards from "../../../components/NappiesCards";
import OTCards from "../../../components/OTCards";

interface MessageProps {
  message: IMessage;
  isLastMessage: boolean;
}

const Message = ({ message, isLastMessage }: MessageProps) => {
  const { addTheme, setAddTheme } = useTheme();

  return (
    <div className={classnames("chat-list mb-3")}>
      <div className="conversation-list w-100 d-flex flex-column" style={{ maxWidth: 800 }}>
        {message?.type === "human" && <UserMessage message={message} />}
        {message?.type === "ai" && <AIMessage message={message} isLastMessage={isLastMessage} />}

        <div className="col-auto">
          {message?.data?.content && message?.type === "ai" && (
            <div className="d-flex align-items-center">
              <ButtonCopyMessage message={message?.data?.content} />
            </div>
          )}
        </div>

        <div>
          {message?.data?.content.includes("Would you like to adjust the chat colour") && (
            <DotsTheme addTheme={addTheme} applyTheme={setAddTheme} />
          )}
          {message?.data?.content.includes("No problem, how about these nappies options") && (
            <NappiesCards />
          )}
          {message?.data?.content.includes("No problem, how about these OT options") && (
            <OTCards />
          )}
        </div>
      </div>
    </div>
  );
};

export default Message;
